import { alteredConsciousnessFlow } from "../../../content/interactive-cases/altered-consciousness";
import { CaseWorkspace } from "../case-workspace/CaseWorkspace";

export function AlteredConsciousnessCase() {
  return <CaseWorkspace flow={alteredConsciousnessFlow} />;
}
